// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"db96c464","239":"f694278a","453":"706e8f18","455":"ead16d79"}[chunkId] + ".chunk.js";
};